import React from 'react'
import styled, { css } from 'styled-components'
import Button from './Button'
import Container from './Container'
import { BodyCopy, H1, H2, H3, H4, H5, H6 } from './Typography'
import Title, { StyledTitle } from './Title'
import { FullAbsolute } from '../styles/Utils'
import media from 'css-in-js-media'
import { Row, Col } from 'react-styled-flexboxgrid'
import ResponsiveImage from './ResponsiveImage'
import { SlideshowSection } from './Slideshow'
import { X2HeadingSection } from './X2HeadingSection'
import { StyledButton } from './ButtonStyled'
import { Variables } from '../styles/Variables'

export const Copy = styled.div`
    margin: 30px auto 20px auto;

    :last-child {
        margin-bottom: 0;
    }

    ${(props) =>
        props.copyWidth &&
        css`
            ${media('>=desktop')} {
                max-width: ${props.copyWidth}px;
            }
        `}

    ${(props) =>
        props.align == 'center' &&
        css`
            text-align: center;
        `}

    ${(props) =>
        props.align == 'left' &&
        css`
            margin-left: 0;
        `}

    ${BodyCopy} {
        font-family: ${Variables.font.title};
        font-style: normal;
        font-weight: 300;
        font-size: 38px;
        line-height: 44px;
        ${media('<desktop')} {
            font-size: 24px;
            line-height: 30px;
        }
        h5,
        h2 {
            font-family: ${Variables.font.title};
            font-style: normal;
            font-weight: 300;
            font-size: 38px;
            line-height: 44px;

            ${media('<desktop')} {
                font-size: 24px;
                line-height: 30px;
            }
        }
        p strong {
            display: inline-block;
            margin-bottom: 10px;
            font-weight: normal;
        }
    }
`

export const Buttons = styled.div`
    margin-top: 30px;
    ${media('>=desktop')} {
        margin-left: -20px;
        margin-right: -20px;
    }
    ${StyledButton} {
        ${media('<desktop')} {
            display: block;
            width: 100%;
        }
        ${media('>=desktop')} {
            margin-left: 20px;
            margin-right: 20px;
        }
    }

    ${StyledButton} + ${StyledButton} {
        ${media('<desktop')} {
            margin-top: 20px;
        }
    }
    ${(props) =>
        props.align == 'center' &&
        css`
            ${media('>=desktop')} {
                text-align: center;
            }
        `}
`

export const StyledHeading = styled.section<{ alignment?: string }>`
    position: relative;
    word-wrap: normal;
    resize: none;
    box-sizing: border-box;
    background-color: ${Variables.color.white};

    ${(props) =>
        !props.noMargin &&
        css`
            padding-left: 20px;
            padding-right: 20px;
            padding-top: 60px;
            padding-bottom: 60px;
            ${media('>=desktop')} {
                padding-left: 172px;
                padding-right: 172px;
                padding-top: ${(props) => (props.alignment == 'center' ? '80px' : '120px')};
                padding-bottom: ${(props) => (props.alignment == 'center' ? '80px' : '120px')};
            }
        `}

    ${(props) =>
        props.withBackground &&
        css`
            ${media('<desktop')} {
                display: flex;
                flex-direction: column-reverse;
            }
        `}

    ${({ backgroundColor }) =>
        backgroundColor &&
        backgroundColor == 'offwhite' &&
        css`
            background-color: ${Variables.color.pazolaKarry};
            ${StyledTitle} {
                h3 {
                    color: ${Variables.color.pazola};
                    font-family: ${Variables.font.title};
                    font-style: normal;
                    font-weight: 300;
                    font-size: 38px;
                    line-height: 44px;
                    text-align: center;
                    letter-spacing: inherit;
                    text-transform: inherit;
                    ${media('<desktop')} {
                        font-size: 24px;
                        line-height: 30px;
                    }
                }
            }
        `}

    ${StyledTitle} {
        white-space: pre-wrap;
        h3 {
            font-family: ${Variables.font.title};
        }
    }

    ${({ alignment }) =>
        alignment == 'left' &&
        css`
            ${StyledTitle} {
                margin-left: 0;
            }
        `}

    ${StyledTitle},
    + ${SlideshowSection},
    + ${X2HeadingSection} {
        margin-top: 0;
    }
`

const HeadingImage = styled.div`
    ${(props) =>
        props.position == 'Bottom' &&
        css`
            margin-top: 30px;
        `}

    ${(props) =>
        props.position == 'Top' &&
        css`
            margin-bottom: 30px;
        `}

        ${ResponsiveImage} {
        margin: 0;
    }
`

const Inner = styled.div``

export const HeadingColumnInner = styled.div`
    text-align: left;

    ${({ align }) =>
        align &&
        css`
            text-align: ${align};
        `}

    ${({ align }) =>
        align == 'left' &&
        css`            
            ${H2} {
                ${media('>=desktop')} {
                    font-size: 48px;
                    line-height: 62px;
                }
            }
            ${H1},
            ${H2},
            ${H3} {
                font-family: ${Variables.font.bodyBold};
                font-size: 16px;
                line-height: 100%;
                letter-spacing: 0.1em;
                text-transform: uppercase;
                margin-left: 0;
                ${media('<desktop')} {
                    font-size: 12px;
                    line-height: 130%;
                }
            }
        `}

    ${({ mobileAlignment }) =>
        mobileAlignment &&
        css`
            ${media('<desktop')} {
                text-align: ${mobileAlignment};
            }

            ${Copy} {
                ${media('<desktop')} {
                    text-align: ${mobileAlignment};
                }
            }
        `}
`

const Wrap = styled.div`
    position: relative;
    z-index: 10;
    ${(props) =>
        props.withBackground &&
        css`
            ${media('<desktop')} {
                padding-top: 40px;
            }
            ${media('>=desktop')} {
                ${FullAbsolute}
                z-index: 10;
                display: flex;
                align-items: center;
                justify-content: center;
            }
        `}

    ${(props) =>
        !props.noMargin &&
        css`
            ${media('<desktop')} {
                /* margin-left: 30px; */
                /* margin-right: 30px; */
            }
        `}
`

const BackgroundImage = styled.div`
    position: relative;

    &:after {
        ${media('>=desktop')} {
            content: '';
            ${FullAbsolute}
            background: rgba(0, 0, 0, 0.5);
        }
    }
`

function GetTitle({ text, size }) {
    return (
        <>
            {
                {
                    h1: <H1>{text}</H1>,
                    h2: <H2>{text}</H2>,
                    h3: <H3>{text}</H3>,
                    h4: <H4>{text}</H4>,
                    h5: <H5>{text}</H5>,
                    h6: <H6>{text}</H6>,
                }[size]
            }
        </>
    )
}

const Column1: React.FC<{
    data: object
}> = ({ data }) => {
    return (
        <>
            <HeadingColumnInner align={data.alignment} mobileAlignment={data.mobileAlignment}>
                {data.image && data.headingImagePosition == 'Top' && (
                    <HeadingImage position={data.headingImagePosition}>
                        <ResponsiveImage image={data.image} />
                    </HeadingImage>
                )}
                <Title titleWidth={data.titleWidth} noMargin={true}>
                    {data.titleSize ? (
                        GetTitle({ text: data.headingTitle.headingTitle, size: data.titleSize })
                    ) : (
                        <H5>{data?.headingTitle?.headingTitle}</H5>
                    )}
                </Title>
                {data.copy && (
                    <Copy copyWidth={data.copyWidth} align={data.alignment}>
                        <BodyCopy
                            dangerouslySetInnerHTML={{
                                __html: data.copy.childMarkdownRemark.html,
                            }}
                        />
                    </Copy>
                )}
                {data.buttons && (
                    <Buttons align={data.alignment}>
                        {data.buttons.map((button, i) => {
                            return (
                                <Button key={i} buttonLink={button.buttonLink}>
                                    {button.text}
                                </Button>
                            )
                        })}
                    </Buttons>
                )}
                {data.image && data.headingImagePosition == 'Bottom' && (
                    <HeadingImage position={data.headingImagePosition}>
                        <ResponsiveImage image={data.image} />
                    </HeadingImage>
                )}
            </HeadingColumnInner>
        </>
    )
}

const Column2Container = styled(Container)`
    ${Col} {
        ${media('<desktop')} {
            width: 100%;
        }
    }
    ${Copy} {
        margin-bottom: 0;
        ${media('>=desktop')} {
            margin-top: 0;
        }
    }

    ${media('<desktop')} {
        padding-left: 0;
        padding-right: 0;
    }
`

const Column2: React.FC<{
    data: object
}> = ({ data }) => {
    return (
        <>
            <Column2Container narrow>
                <Row>
                    <Col md={6}>
                        <Title
                            align={data.alignment}
                            titleWidth={data.titleWidth}
                            noMarginBottom={data.copy ? true : false}
                        >
                            {data.titleSize ? (
                                GetTitle({ text: data.headingTitle.headingTitle, size: data.titleSize })
                            ) : (
                                <H2>{data.headingTitle.headingTitle}</H2>
                            )}
                        </Title>
                    </Col>
                    <Col md={6}>
                        {data.image && data.headingImagePosition == 'Top' && (
                            <HeadingImage position={data.headingImagePosition}>
                                <ResponsiveImage image={data.image} />
                            </HeadingImage>
                        )}
                        {data.copy && (
                            <Copy align={data.alignment} copyWidth={data.copyWidth}>
                                <BodyCopy
                                    dangerouslySetInnerHTML={{
                                        __html: data.copy.childMarkdownRemark.html,
                                    }}
                                />
                            </Copy>
                        )}
                        {data.buttons && (
                            <Buttons align={data.alignment}>
                                {data.buttons.map((button, i) => {
                                    const buttonTheme =
                                        button.theme == 'primary' ? { primary: true } : { secondary: true }

                                    return (
                                        <Button key={i} href={button.link} {...buttonTheme}>
                                            {button.text}
                                        </Button>
                                    )
                                })}
                            </Buttons>
                        )}
                        {data.image && data.headingImagePosition == 'Bottom' && (
                            <HeadingImage size={data.image.maxWidth} position={data.headingImagePosition}>
                                <HeadingImage position={data.headingImagePosition}>
                                    <ResponsiveImage image={data.image} />
                                </HeadingImage>
                            </HeadingImage>
                        )}
                    </Col>
                </Row>
            </Column2Container>
        </>
    )
}

const Heading: React.FC<{
    data: object
    noMargin?: boolean
}> = ({ data, noMargin }) => {
    const { backgroundImage, layout, backgroundColor, alignment } = data

    return (
        <>
            <StyledHeading
                alignment={alignment}
                noMargin={noMargin}
                withBackground={backgroundImage ? true : false}
                backgroundColor={backgroundColor}
            >
                <Wrap withBackground={backgroundImage ? true : false} noMargin={noMargin}>
                    <Inner>{layout == '2 Columns' ? <Column2 data={data} /> : <Column1 data={data} />}</Inner>
                </Wrap>
                {backgroundImage && (
                    <BackgroundImage>
                        <ResponsiveImage image={backgroundImage} />
                    </BackgroundImage>
                )}
            </StyledHeading>
        </>
    )
}

export default Heading
